module.exports = __webpack_public_path__ + "img/pic_312592_2.96160cab.jpg";